import React, { useContext } from 'react'
import reduce from 'lodash/reduce'
import PropTypes from 'prop-types'
import Img from 'gatsby-image'
import { navigate } from 'gatsby'
import { useStaticQuery, graphql } from 'gatsby'
import Marquee from 'react-fast-marquee'

import Wiggle from '~/icons/Wiggle'
import SocialIcons from '~/components/SocialIcons'
import StarRating from '~/components/StarRating'

import StoreContext from '~/context/StoreContext'
import {
  CartCounter,
  Container,
  MenuLink,
  Wrapper,
  Nav,
  Banner,
  MenuIcon,
  MenuIconWrap,
  LogoWrapper,
  BannerWrapper,
  MobileMenu,
  MobileMenuLink,
} from './styles'

const useQuantity = () => {
  const {
    store: { checkout },
  } = useContext(StoreContext)
  const items = checkout ? checkout.lineItems : []
  const total = reduce(items, (acc, item) => acc + item.quantity, 0)
  return [total !== 0, total]
}

const toggleMenu = () => {
  const menu = document.querySelector('.js-menu')
  if (menu) {
    menu.classList.toggle('is-visible')
  }
}

const hideMenu = () => {
  const menu = document.querySelector('.js-menu')
  if (menu) {
    menu.classList.remove('is-visible')
  }
}

const Navigation = ({
  siteTitle,
  isWholesale = false,
  hideHeaderBanner = false,
}) => {
  const [hasItems, quantity] = useQuantity()
  const data = useStaticQuery(
    graphql`
      query {
        logo: file(relativePath: { eq: "logo.png" }) {
          childImageSharp {
            fluid(maxWidth: 200) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    `
  )

  return (
    <>
      <Wrapper className="js-header">
        <Container>
          {!isWholesale && (
            <MenuIconWrap onClick={() => toggleMenu()}>
              <MenuIcon />
            </MenuIconWrap>
          )}
          <Nav>
            <ul>
              <li>
                {isWholesale ? (
                  <>&nbsp;</>
                ) : (
                  <MenuLink to="/shop">Shop</MenuLink>
                )}
              </li>
              <li>
                {isWholesale ? (
                  <>&nbsp;</>
                ) : (
                  <MenuLink to="/learn">Learn</MenuLink>
                )}
              </li>
            </ul>
          </Nav>

          <MobileMenu className="js-menu">
            <div className="content">
              <ul className="navigation">
                <li>
                  <MobileMenuLink onClick={() => hideMenu()} to="/">
                    Home
                  </MobileMenuLink>
                </li>
                <li>
                  <MobileMenuLink onClick={() => hideMenu()} to="/shop">
                    Shop
                  </MobileMenuLink>
                </li>
                <li>
                  <MobileMenuLink onClick={() => hideMenu()} to="/learn">
                    Learn
                  </MobileMenuLink>
                </li>
              </ul>

              <SocialIcons />
            </div>
          </MobileMenu>

          <a
            onClick={e => {
              e.preventDefault()
              if (typeof window !== 'undefined') {
                if (window.location.href.indexOf('wholesale') > -1) {
                  return
                } else {
                  hideMenu()
                  navigate('/')
                }
              }
            }}
            style={{
              width: 140,
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              cursor: 'pointer',
            }}
          >
            <LogoWrapper>
              <Img fluid={data.logo.childImageSharp.fluid} />
            </LogoWrapper>
          </a>

          <MenuLink
            to="/cart"
            style={{ zIndex: 10 }}
            onClick={() => hideMenu()}
          >
            <span>Cart</span>
            {hasItems && <CartCounter>{quantity}</CartCounter>}
          </MenuLink>
        </Container>
      </Wrapper>
      {!hideHeaderBanner && (
        <BannerWrapper>
          <Banner>FREE EXPRESS SHIPPING – ALL 5* REVIEWS</Banner>
        </BannerWrapper>
      )}
    </>
  )
}

Navigation.propTypes = {
  siteTitle: PropTypes.string,
}

Navigation.defaultProps = {
  siteTitle: ``,
}

export default Navigation
